import API from "../Services/API";
import Model from "./Model";

const features = {
    CUSTOMERS            : 'Unlimited Customers',
    CUSTOMER_PORTAL      : 'Customer Portal',
    ROUNDS               : 'Unlimited Rounds',
    ROUTE_OPTIMISATION   : 'Route Optimisation',
    WEEK_PLANNER         : 'Calendar Planner',
    ADVANCED_SCHEDULING  : 'Advanced Scheduling',
    CARDS_PAYMENTS       : 'Card Payments',
    DIRECT_DEBIT         : 'Direct Debit',
    BANK_RECONCILIATION  : 'Bank Reconciliation',
    BASIC_WEBSITE        : 'Website',
    CUSTOM_DOMAIN        : 'Custom Domain',
    AUTO_REPLY           : 'Auto Reply',
    SAVED_REPLIES        : 'Saved Replies',
    AI_ASSISTANT         : 'AI Assistant',
    VERIFICATION         : 'Verification',
    REVIEWS              : 'Reviews',
    REFER_FRIEND         : 'Refer A Friend',
    SMS_CUSTOM_NAME      : 'SMS Custom Name',
    EXPENSES             : 'Expenses',
    ADDITIONAL_USERS     : 'Additional Users',
    LOWEST_SMS_COST      : 'Lowest SMS Cost',
    LOYALTY_CARDS        : 'Loyalty Cards',
    DOCUMENTS            : 'Documents',
    BROADCASTS           : 'Broadcasts',
    TAGS                 : 'Tags',
    SAVED_SEARCHES       : 'Saved Searches',
};

const unreleased = [
    // 'WEEK_PLANNER',
    // 'SAVED_REPLIES',
    // 'AI_ASSISTANT',
    'AUTO_REPLY',
    'VERIFICATION',
    'REVIEWS',
    'REFER_FRIEND',
    // 'LOYALTY_CARDS',
    // 'DOCUMENTS',
    // 'CUSTOM_DOMAIN',
    // 'ADDITIONAL_USERS',
    // 'BROADCASTS',
];

const hidden = [
    'VERIFICATION',
    'AUTO_REPLY',
    // 'CUSTOM_DOMAIN',
];

const descriptions = {
    'PLUS': 'Perfect for businesses on the rise, looking to boost their performance.',
    'PRO': 'Perfect for businesses on the rise, looking to boost their performance.',
    'BASIC': 'Good for businesses that are growing and need to get more organized.',
    'STANDARD': 'Good for businesses that are growing and need to get more organized.',
    'FREE': 'Great for new or small businesses with not too much work to handle.',
}

const usePlans = (alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'plans',
        stateKey: 'plans',
        fetchData: async () => API.get('/balance/plans'),
        defaultLoadingError: 'Sorry, there was an error loading plans.',
    })
}

const enableNewPlans = new Date() >= new Date('2024-03-01T00:00:00Z');

export {
    features,
    usePlans,
    unreleased,
    hidden,
    descriptions,
    enableNewPlans,
}
